import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      ;(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = true
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = true
        t.src = v
        s = b.getElementsByTagName(e)[0]
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s)
        } else {
          // Fallback: append to head if no script tag exists
          b.head.appendChild(t)
        }
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js',
      )

      window.fbq('init', '767419773080588')
      window.fbq('track', 'PageView')
    }
  }, [])

  const trackAddToCart = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Avatar Digital Rentable',
        content_ids: ['49940485964022'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }
  }

  return { trackAddToCart }
}
